import { publicAssetsURL } from '#internal/nuxt/paths';export default publicAssetsURL("/startup/figure.png")